interface IPagesList {
    id: string,
    url: string
}


const pagesList: IPagesList[] = [
    {
        id: "download",
        url: `/download/:id?`
    }
]

export default pagesList;
